export default __webpack_public_path__ + "static/media/crystal.caa1a56b.svg";